var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"PILL p-x-2:t btn-sm p-x-1:mo bd-transparent",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('span',{staticClass:"TEXT"},[_vm._v(_vm._s(_vm.label))]),_c('vk-icon',{staticClass:"m-l-1",class:_vm.xClass,attrs:{"name":"close","size":"10"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }